import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { EndpointKey } from '../http/EndpointKey';
import imageUrls from '../images/imageUrls';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { CheckYourEmailMessage } from '../step-check-your-email/CheckYourEmailMessage';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const VerifyFirstCreationError = () => {
  const {
    data: email
  } = useSignupData(Data.Email);
  const dispatch = useDispatch();
  const errorKey = ErrorKey.VerifyFirstCreationError;

  const onClick = () => {
    dispatch(retryEndpoint(EndpointKey.Signup));
  };

  const renderContent = () => {
    return /*#__PURE__*/_jsx("div", {
      className: "m-top-8",
      children: /*#__PURE__*/_jsx(CheckYourEmailMessage, {
        email: email
      })
    });
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    imageURL: imageUrls.email,
    renderContent: renderContent,
    onSentenceWithLinkClick: onClick
  });
};

export default VerifyFirstCreationError;